// extracted by mini-css-extract-plugin
export default {"container":"go-z","bubbleNav":"ho-z","graphic":"io-z","contact":"jo-z"};